/**
 * Home preview of the Served wall — the latest verified cases, with a CTA to the full,
 * searchable wall. Scroll-revealed; skeletons while loading.
 */
import { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { publicApi } from '../lib/publicApi.js';
import { ServedCard, ServedCardSkeleton } from '../components/served/ServedCard.jsx';
import { Button } from '../components/ui/Button.jsx';
import { useReveal } from '../hooks/useReveal.js';
import styles from './ServedPreview.module.css';

export function ServedPreview() {
  const [state, setState] = useState({ status: 'loading', items: [] });
  const ref = useReveal();

  useEffect(() => {
    publicApi
      .served({ limit: 6 })
      .then((env) => setState({ status: 'ready', items: env.data }))
      .catch(() => setState({ status: 'error', items: [] }));
  }, []);

  return (
    <section id="served" className="container">
      <div className={styles.head}>
        <div>
          <p className="eyebrow">The Served wall</p>
          <h2>Real, proven, dated help.</h2>
        </div>
        <Button to="/served" variant="ghost" iconRight={ArrowRight}>
          See the whole wall
        </Button>
      </div>

      <div ref={ref} className={styles.grid} data-revealed="false">
        {state.status === 'loading' &&
          Array.from({ length: 6 }).map((_, i) => <ServedCardSkeleton key={i} />)}
        {state.status === 'ready' &&
          state.items.map((item, i) => (
            <div key={item.id} className={styles.cell} style={{ '--i': i }}>
              <ServedCard item={item} />
            </div>
          ))}
        {state.status === 'error' && (
          <p className={styles.error}>The wall is loading — start the backend to see live cases.</p>
        )}
      </div>
    </section>
  );
}

export default ServedPreview;
